function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "search-active",
  transform: "translate(-204 -5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Caminho_1100",
  "data-name": "Caminho 1100",
  transform: "translate(204 5)",
  fill: "#d6d6d6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 19.20000076293945 23 L 4.800000190734863 23 C 2.704669952392578 23 1 21.29533004760742 1 19.20000076293945 L 1 4.800000190734863 C 1 2.704669952392578 2.704669952392578 1 4.800000190734863 1 L 19.20000076293945 1 C 21.29533004760742 1 23 2.704669952392578 23 4.800000190734863 L 23 19.20000076293945 C 23 21.29533004760742 21.29533004760742 23 19.20000076293945 23 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 4.799999237060547 2 C 3.256069183349609 2 2 3.256069183349609 2 4.799999237060547 L 2 19.20000076293945 C 2 20.74393081665039 3.256069183349609 22 4.799999237060547 22 L 19.20000076293945 22 C 20.74393081665039 22 22 20.74393081665039 22 19.20000076293945 L 22 4.799999237060547 C 22 3.256069183349609 20.74393081665039 2 19.20000076293945 2 L 4.799999237060547 2 M 4.799999237060547 0 L 19.20000076293945 0 C 21.8509693145752 0 24 2.149030685424805 24 4.799999237060547 L 24 19.20000076293945 C 24 21.8509693145752 21.8509693145752 24 19.20000076293945 24 L 4.799999237060547 24 C 2.149030685424805 24 0 21.8509693145752 0 19.20000076293945 L 0 4.799999237060547 C 0 2.149030685424805 2.149030685424805 0 4.799999237060547 0 Z",
  stroke: "none",
  fill: "#d6d6d6"
})), /*#__PURE__*/React.createElement("g", {
  id: "search",
  transform: "translate(209 9)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Elipse_1",
  "data-name": "Elipse 1",
  cx: 5.515,
  cy: 5.479,
  rx: 5.515,
  ry: 5.479,
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_14",
  "data-name": "Linha 14",
  x1: 4.86,
  y1: 6.317,
  transform: "translate(8.74 9.683)",
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "close-btn",
  transform: "translate(212.57 12.57)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_505",
  "data-name": "Grupo 505",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1403",
  "data-name": "Ret\\xE2ngulo 1403",
  width: 0.276,
  height: 5.989,
  transform: "translate(0 0.195) rotate(-45)",
  fill: "#9c9c9c",
  stroke: "#707070",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_506",
  "data-name": "Grupo 506",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1404",
  "data-name": "Ret\\xE2ngulo 1404",
  width: 5.989,
  height: 0.276,
  transform: "translate(0 4.235) rotate(-45)",
  fill: "#9c9c9c",
  stroke: "#707070",
  strokeWidth: 1
}))));

function SvgSearchActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActive);
export default __webpack_public_path__ + "static/media/search-active.ab435bac.svg";
export { ForwardRef as ReactComponent };